// Session timeout configuration
const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds
const WARNING_TIME = 2 * 60 * 1000; // Show warning 2 minutes before logout

class SessionManager {
  constructor() {
    this.timeout = null;
    this.warningTimeout = null;
    this.warningCallback = null;
  }

  // Initialize session monitoring
  init(onWarning, onLogout) {
    this.warningCallback = onWarning;
    this.logoutCallback = onLogout;

    // Set up activity listeners
    this.setupActivityListeners();

    // Start the timer
    this.resetTimer();
  }

  // Set up event listeners for user activity
  setupActivityListeners() {
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach((event) => {
      document.addEventListener(event, () => this.resetTimer(), true);
    });
  }

  // Reset the inactivity timer
  resetTimer() {
    // Clear existing timers
    if (this.timeout) clearTimeout(this.timeout);
    if (this.warningTimeout) clearTimeout(this.warningTimeout);

    // Set warning timer (show warning before logout)
    this.warningTimeout = setTimeout(() => {
      if (this.warningCallback) {
        this.warningCallback();
      }
    }, INACTIVITY_TIMEOUT - WARNING_TIME);

    // Set logout timer
    this.timeout = setTimeout(() => {
      this.logout();
    }, INACTIVITY_TIMEOUT);
  }

  // Force logout
  logout() {
    if (this.logoutCallback) {
      this.logoutCallback();
    }

    // Clear all auth data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");

    // Redirect to login
    window.location.href = "/login";
  }

  // Extend session (when user clicks "Stay logged in")
  extendSession() {
    this.resetTimer();
  }

  // Clean up (call when component unmounts)
  cleanup() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.warningTimeout) clearTimeout(this.warningTimeout);
  }
}

// Create instance and export
const sessionManager = new SessionManager();
export default sessionManager;
